import { Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { NgSelectModule } from "@ng-select/ng-select";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LoaderService } from "../services/loader.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { JwtInterceptor } from "../helpers/jwt.interceptor";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NotificationService } from "app/service/notification.service";
import { PullProductFormModel } from "../models/pull-products-form.model";
import { Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { USER_AUTHENTICATION_SERVICE, UserAuthInterface } from "../services/user-auth.interface";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { PullDataStateService } from "../services";

@Component({
    selector: 'app-pull-data-form',
    templateUrl: 'pull-data-form.component.html',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        }
    ]
})
export class PullDataFormComponent implements OnInit {

    //#region Feilds
    submitted: boolean = false;
    loadingButton: boolean;
    pullDataFormFormModel: PullProductFormModel;
    today: string = new Date().toISOString().split('T')[0];
    @ViewChild("submitBtn") submitButton!: ElementRef<HTMLButtonElement>;

    _materialTypeList = [
        { text: 'Diamond', value: 1 },
        { text: 'Gold', value: 2 },
    ];
    //#endregion

    //#region Construtor
    constructor(
        private router: Router,
        private toastr: NotificationService,
        private _loaderService: NgxUiLoaderService,
        public activeModal: NgbActiveModal,
        private loaderService: LoaderService,
        private _dataState: PullDataStateService,
        @Inject(USER_AUTHENTICATION_SERVICE) private _userAuthInterface: UserAuthInterface,
    ) { }
    //#endregion

    //#region properties
    get f() {
        return this.pullDataFormFormModel.controls;
    }
    //#endregion

    //#region Methods
    ngOnInit(): void {
        this.pullDataFormFormModel = new PullProductFormModel();
    }

    onSubmit() {
        this.submitted = true;
        if (this.pullDataFormFormModel.invalid) return;
        this._loaderService.start();
        this.loadingButton = true;
        this.loaderService.show();
        this.submitButton.nativeElement.disabled = true;
        const customerData = this.pullDataFormFormModel.getPullProductData();
        this._userAuthInterface.pullProductData(customerData).subscribe({
            next: (res) => {
                this.submitButton.nativeElement.disabled = false;
                this.loaderService.hide();
                this.loadingButton = false;
                this.toastr.showSuccess(res.message, 'Pull Products');
                this.cancelAddUpdateModel();
                this._dataState.setData({
                    validProductHeader: res.data.validProductHeader,
                    inValidProductHeader: res.data.inValidProductHeader
                });
                this.router.navigate(['snmcc-inventory/snmcc-import-modal']);
                this._loaderService.stop();

            },
            error: (err) => {
                this.submitButton.nativeElement.disabled = false;
                this.loaderService.hide();
                this.loadingButton = false;
                this._loaderService.stop();
                this.toastr.showError(err.message, 'Pull Products');
            },
            complete: () => {
                this.submitButton.nativeElement.disabled = false;
                this.loadingButton = false;
                this.loaderService.hide();
                this._loaderService.stop();

            }
        });
    }


    cancelAddUpdateModel() {
        this.activeModal.close();
    }
    //#endregion
}